var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BackDropComponent from "@/components/BackDrop";
import { getAccountTypeRequest, getActiveWalletPlanRequest, getCompanyMetaDataRequest, getKycInfoRequest, getRemittancePayoutCycleRequest, getSellerWalletPlansRequest, updateAccountTypeRequest, updateAdminRechargeDataRequest, updateAdminRechargeDataReset, updateKYCstateRequest, updateKYCstateReset, updateRemittancePayoutCycleRequest, updateSellerWalletPlanRequest, } from "@/redux/actions";
import { getDateString } from "@/utils/Common";
import { DEDUCTION_TYPES } from "@/utils/Constants";
import { Button, Card, CardContent, Divider, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../scss/main.scss";
import KYCdetails from "./KYCdetails";
import "./TenantManager.scss";
const TenantManagerDetails = () => {
    var _a, _b, _c;
    const [actionType, setActionType] = React.useState("");
    const [rechargeType, setRechargeType] = React.useState("");
    const [activeAccountType, setActiveAccountType] = React.useState();
    const [deductType, setDeductType] = React.useState("");
    const [addAmount, setAddAmount] = React.useState("");
    const [deductAmount, setDeductAmount] = React.useState("");
    const [tenantId, setTenantId] = React.useState(null);
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const UpdateAdminRechargeState = useSelector((state) => state.UpdateAdminRechargereducer);
    const UpdateKYCState = useSelector((state) => state.updateKYCstateReducer);
    const [walletTiers, setWalletTiers] = React.useState([]);
    const [activePlan, setActivePlan] = React.useState("");
    const [walletOperationType, setWalletOperationType] = React.useState("credit");
    const [companyName, setCompanyName] = React.useState("");
    const [userName, setUserName] = React.useState("");
    const [emailId, setEmailID] = React.useState("");
    const [phoneNumber, setPhoneNumber] = React.useState("");
    const [tenantType, setTenantType] = React.useState("");
    const [createdAt, setCreatedAt] = React.useState("");
    const [accountType, setAccountType] = React.useState("");
    const [kycStatus, setKycStatus] = React.useState("");
    const [selectedTier, setSelectedTier] = React.useState("Prepaid");
    const SellerWalletPlansState = useSelector((state) => state.getSellerWalletPlansReducer);
    const SellerActivePlanState = useSelector((state) => state.getActiveWalletPlanReducer);
    const UpdateActiveWalletPlanState = useSelector((state) => state.updateActiveWalletPlanReducer);
    const ActiveAccountTypeState = useSelector((state) => state.getActiveAccountTypeReducer);
    const UpdateActiveAccountTypeState = useSelector((state) => state.updateActiveAccountTypeReducer);
    const getCompanyMetaDataState = useSelector((state) => state.getCompanyMetaDataReducer);
    const getKycInfoState = useSelector((state) => state.getKycInfoReducer);
    // Remittance Payout cycle
    const [activePayoutCycle, setActivePayoutCycle] = React.useState("");
    const [currentBillingCycle, setCurrentBillingCycle] = React.useState("");
    const [currentBillingCycleStartTimestamp, setCurrentBillingCycleStartTimestamp] = React.useState("");
    const [upcomingBillingCycle, setupcomingBillingCycle] = React.useState("");
    const [upcomingBillingCycleStartTimestamp, setUpcomingBillingCycleStartTimestamp] = React.useState("");
    const [selectedPayoutCycle, setSelectedPayoutCycle] = React.useState("");
    const getRemittancePayoutCycleState = useSelector((state) => state.getRemittnacePayoutCycleReducer);
    const UpdateRemittancePayoutCycleState = useSelector((state) => state.updateRemittnacePayoutCycleReducer);
    const location = useLocation();
    const selectedTenant = (_a = location.state) === null || _a === void 0 ? void 0 : _a.selectedTenant;
    React.useEffect(() => {
        const updateTenantId = () => {
            const id = localStorage.getItem("tenantId");
            setTenantId(id);
        };
        updateTenantId(); // Get it on initial render
        window.addEventListener("tenantIdChanged", updateTenantId); // Listen for updates
        return () => {
            window.removeEventListener("tenantIdChanged", updateTenantId); // Clean up
        };
    }, []);
    React.useEffect(() => {
        setIsBackOpenOpen(true);
        const id = localStorage.getItem("tenantId");
        dispatch(getSellerWalletPlansRequest({}));
        dispatch(getActiveWalletPlanRequest({ tenantId: id }));
        dispatch(getAccountTypeRequest({ tenantId: id }));
        dispatch(getRemittancePayoutCycleRequest({ tenantId: id }));
        dispatch(getCompanyMetaDataRequest({ tenantId: id }));
        dispatch(getKycInfoRequest({ tenantId: id }));
    }, [tenantId]);
    const handleSaveClick = (type) => __awaiter(void 0, void 0, void 0, function* () {
        setIsBackOpenOpen(true);
        setActionType(type);
        // Get IP address
        const ipPromise = fetch("https://api.ipify.org?format=json")
            .then((res) => res.json())
            .then((data) => data.ip)
            .catch(() => "");
        // Get Geolocation
        const locationPromise = new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            }, () => {
                resolve({ latitude: 0, longitude: 0 });
            });
        });
        const [ipAddress, location] = yield Promise.all([ipPromise, locationPromise]);
        const payload = {
            tenantId: tenantId,
            amount: type === "add" ? addAmount : deductAmount,
            currencyCode: "INR",
            countryCode: "IN",
            chargeType: type === "add" ? rechargeType : deductType,
            rechargeId: "",
            clientDetails: {
                localClientTimestamp: new Date().toISOString(),
                latitude: location.latitude,
                longitude: location.longitude,
                ipAddress: ipAddress,
            },
            billingAddress: null,
        };
        dispatch(updateAdminRechargeDataRequest(payload));
    });
    React.useEffect(() => {
        var _a;
        if (UpdateAdminRechargeState && ((_a = UpdateAdminRechargeState === null || UpdateAdminRechargeState === void 0 ? void 0 : UpdateAdminRechargeState.updateData) === null || _a === void 0 ? void 0 : _a.tenantId)) {
            enqueueSnackbar(`Wallet ${actionType === "add" ? "recharge" : "deduct"} successfully.`, {
                variant: "success",
            });
            dispatch(updateAdminRechargeDataReset());
            setIsBackOpenOpen(false);
        }
        else if (UpdateAdminRechargeState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateAdminRechargeState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateAdminRechargeState]);
    React.useEffect(() => {
        if (SellerWalletPlansState && (SellerWalletPlansState === null || SellerWalletPlansState === void 0 ? void 0 : SellerWalletPlansState.walletPlansData)) {
            setIsBackOpenOpen(false);
            console.log("SellerWalletPlansState", SellerWalletPlansState === null || SellerWalletPlansState === void 0 ? void 0 : SellerWalletPlansState.walletPlansData);
            setWalletTiers((SellerWalletPlansState === null || SellerWalletPlansState === void 0 ? void 0 : SellerWalletPlansState.walletPlansData) || []);
        }
        else if (SellerWalletPlansState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(SellerWalletPlansState.error.message, {
                variant: "error",
            });
        }
    }, [SellerWalletPlansState]);
    React.useEffect(() => {
        if (ActiveAccountTypeState && (ActiveAccountTypeState === null || ActiveAccountTypeState === void 0 ? void 0 : ActiveAccountTypeState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActiveAccountType(ActiveAccountTypeState.ActivePlanData);
        }
        else if (ActiveAccountTypeState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(ActiveAccountTypeState.error.message, {
                variant: "error",
            });
        }
    }, [ActiveAccountTypeState]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (getCompanyMetaDataState && (getCompanyMetaDataState === null || getCompanyMetaDataState === void 0 ? void 0 : getCompanyMetaDataState.data)) {
            setIsBackOpenOpen(false);
            setCompanyName(((_a = getCompanyMetaDataState.data) === null || _a === void 0 ? void 0 : _a.name) || "NA");
            setUserName(((_b = getCompanyMetaDataState.data.userProfileList[0]) === null || _b === void 0 ? void 0 : _b.firstName) + " " + ((_c = getCompanyMetaDataState.data.userProfileList[0]) === null || _c === void 0 ? void 0 : _c.lastName) || "NA");
            setTenantType(getCompanyMetaDataState.data.tenantType || "NA");
            setCreatedAt(getCompanyMetaDataState.data.created_at || "-");
            setEmailID(((_d = getCompanyMetaDataState.data.userProfileList[0]) === null || _d === void 0 ? void 0 : _d.emailAddress) || "NA");
            setPhoneNumber(((_e = getCompanyMetaDataState.data.userProfileList[0]) === null || _e === void 0 ? void 0 : _e.phoneNumber) || "NA");
        }
        else if (getCompanyMetaDataState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(getCompanyMetaDataState.error.message, {
                variant: "error",
            });
        }
    }, [getCompanyMetaDataState]);
    React.useEffect(() => {
        var _a, _b, _c, _d;
        if (getKycInfoState && (getKycInfoState === null || getKycInfoState === void 0 ? void 0 : getKycInfoState.data)) {
            setIsBackOpenOpen(false);
            setAccountType(((_b = (_a = getKycInfoState.data) === null || _a === void 0 ? void 0 : _a.kycInfo) === null || _b === void 0 ? void 0 : _b.accountType) || "NA");
            setKycStatus(((_d = (_c = getKycInfoState.data) === null || _c === void 0 ? void 0 : _c.kycInfo) === null || _d === void 0 ? void 0 : _d.status) || "NA");
        }
        else if (getKycInfoState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(getKycInfoState.error.message, {
                variant: "error",
            });
        }
    }, [getKycInfoState]);
    React.useEffect(() => {
        var _a;
        if (SellerActivePlanState && (SellerActivePlanState === null || SellerActivePlanState === void 0 ? void 0 : SellerActivePlanState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActivePlan(((_a = SellerActivePlanState === null || SellerActivePlanState === void 0 ? void 0 : SellerActivePlanState.ActivePlanData) === null || _a === void 0 ? void 0 : _a.tierName) || "");
        }
        else if (SellerActivePlanState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(SellerActivePlanState.error.message, {
                variant: "error",
            });
        }
    }, [SellerActivePlanState]);
    React.useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (getRemittancePayoutCycleState && (getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data)) {
            setIsBackOpenOpen(false);
            setCurrentBillingCycle(((_b = (_a = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _a === void 0 ? void 0 : _a.currentConfig) === null || _b === void 0 ? void 0 : _b.calculationCycle) || "");
            setCurrentBillingCycleStartTimestamp(((_d = (_c = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _c === void 0 ? void 0 : _c.currentConfig) === null || _d === void 0 ? void 0 : _d.startTimestamp) || "");
            setupcomingBillingCycle(((_f = (_e = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _e === void 0 ? void 0 : _e.upcomingConfig) === null || _f === void 0 ? void 0 : _f.calculationCycle) || "");
            setUpcomingBillingCycleStartTimestamp(((_h = (_g = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _g === void 0 ? void 0 : _g.upcomingConfig) === null || _h === void 0 ? void 0 : _h.startTimestamp) || "");
            setActivePayoutCycle(((_k = (_j = getRemittancePayoutCycleState === null || getRemittancePayoutCycleState === void 0 ? void 0 : getRemittancePayoutCycleState.data) === null || _j === void 0 ? void 0 : _j.currentConfig) === null || _k === void 0 ? void 0 : _k.remittanceCycle) || "");
        }
        else if (getRemittancePayoutCycleState.error) {
            enqueueSnackbar(getRemittancePayoutCycleState.error.message, {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [getRemittancePayoutCycleState]);
    React.useEffect(() => {
        var _a, _b;
        if (UpdateRemittancePayoutCycleState && (UpdateRemittancePayoutCycleState === null || UpdateRemittancePayoutCycleState === void 0 ? void 0 : UpdateRemittancePayoutCycleState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            setActivePayoutCycle(((_b = (_a = UpdateRemittancePayoutCycleState === null || UpdateRemittancePayoutCycleState === void 0 ? void 0 : UpdateRemittancePayoutCycleState.ActivePlanData) === null || _a === void 0 ? void 0 : _a.currentConfig) === null || _b === void 0 ? void 0 : _b.remittanceCycle) || "");
            enqueueSnackbar("Remittance cycle for the tenant updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateRemittancePayoutCycleState.error) {
            enqueueSnackbar(UpdateRemittancePayoutCycleState.error.message, {
                variant: "error",
            });
            setIsBackOpenOpen(false);
        }
    }, [UpdateRemittancePayoutCycleState]);
    React.useEffect(() => {
        if (UpdateActiveWalletPlanState && (UpdateActiveWalletPlanState === null || UpdateActiveWalletPlanState === void 0 ? void 0 : UpdateActiveWalletPlanState.ActivePlanData)) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Wallet plan updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateActiveWalletPlanState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateActiveWalletPlanState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateActiveWalletPlanState]);
    React.useEffect(() => {
        if (UpdateActiveAccountTypeState && UpdateActiveAccountTypeState.ActivePlanData) {
            setIsBackOpenOpen(false);
            enqueueSnackbar("Account Type updated successfully.", {
                variant: "success",
            });
        }
        else if (UpdateActiveAccountTypeState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateActiveAccountTypeState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateActiveAccountTypeState]);
    React.useEffect(() => {
        if (UpdateKYCState && UpdateKYCState.data) {
            enqueueSnackbar(`KYC state updated successfully.`, {
                variant: "success",
            });
            dispatch(updateKYCstateReset());
            setIsBackOpenOpen(false);
        }
        else if (UpdateKYCState.error) {
            setIsBackOpenOpen(false);
            enqueueSnackbar(UpdateKYCState.error.message, {
                variant: "error",
            });
        }
    }, [UpdateKYCState]);
    const handleKYCstateUpdate = (status) => {
        setIsBackOpenOpen(true);
        dispatch(updateKYCstateRequest({
            tenantId: tenantId,
            kycUpdateState: status,
        }));
    };
    const handleSaveAccountType = () => {
        setIsBackOpenOpen(true);
        dispatch(updateAccountTypeRequest({ activeAccountType }));
    };
    const HandleSaveWalletPlan = () => {
        // setIsBackOpenOpen(true);
        const payload = {
            tenantId: tenantId,
            tenantTier: selectedTier.replace(/\s+/g, ""),
        };
        dispatch(updateSellerWalletPlanRequest(payload));
    };
    const HandleSaveRemittancePayoutCycle = () => {
        if (selectedPayoutCycle === activePayoutCycle) {
            return;
        }
        if (selectedPayoutCycle) {
            setIsBackOpenOpen(true);
            const payload = {
                tenantId: tenantId,
                remittanceCycle: selectedPayoutCycle,
            };
            dispatch(updateRemittancePayoutCycleRequest(payload));
        }
    };
    return (React.createElement(Grid, { container: true, direction: "column", spacing: 3, p: 6 },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center", marginBottom: 1 },
            React.createElement(Grid, { item: true, display: "flex", alignItems: "center", gap: 1 },
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 500, fontSize: "24px", color: "#121114" } }, "Profile and company details"))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "Tenant details"),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Tenant ID"),
                        React.createElement(Typography, { className: "tenant_value" }, tenantId)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Company name"),
                        React.createElement(Typography, { className: "tenant_value" }, companyName)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "KYC"),
                        React.createElement(Typography, { className: "tenant_value" }, kycStatus)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Created at"),
                        getDateString(+createdAt, "MM-DD-YYYY hh:mm a")),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Tenant type"),
                        React.createElement(Typography, { className: "tenant_value" }, tenantType)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Account type"),
                        React.createElement(Typography, { className: "tenant_value" }, ((_c = (_b = accountType === null || accountType === void 0 ? void 0 : accountType.split("_")) === null || _b === void 0 ? void 0 : _b.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())) === null || _c === void 0 ? void 0 : _c.join(" ")) || "-")),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Primary User name"),
                        React.createElement(Typography, { className: "tenant_value" }, userName)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Primary User Email ID"),
                        React.createElement(Typography, { className: "tenant_value" }, emailId)),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key" }, "Primary Phone number"),
                        React.createElement(Typography, { className: "tenant_value" }, phoneNumber))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, alignItems: "center", columnGap: 2, mb: 1 },
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { sx: {
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                fontSize: "16px",
                                color: "#121114",
                            } }, "Change account type")),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { className: "tenant_key" },
                            "(",
                            React.createElement("span", { style: { fontWeight: 700 } }, "Current account type:"),
                            " ",
                            (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) === "PREPAID" ? "Prepaid" : "Postpaid",
                            ")"))),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Change account type"),
                        React.createElement(Select, { style: { width: "82%" }, size: "small", value: (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.accountType) || "", onChange: (e) => setActiveAccountType((prev) => (prev ? Object.assign(Object.assign({}, prev), { accountType: e.target.value }) : prev)), className: "tenant_value" },
                            React.createElement(MenuItem, { value: "PREPAID" }, "Prepaid"),
                            React.createElement(MenuItem, { value: "POSTPAID" }, "Postpaid"))),
                    React.createElement(Grid, { item: true, xs: 6.5 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 },
                            "Is COD deductible (",
                            React.createElement("span", { style: { fontWeight: 700 } }, "Current configuration - Deduct COD:"),
                            " ",
                            (activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible) ? "True" : "False",
                            ")"),
                        React.createElement(Select, { style: { width: "50%" }, size: "small", value: String(activeAccountType === null || activeAccountType === void 0 ? void 0 : activeAccountType.isCodDeductible), onChange: (e) => setActiveAccountType((prev) => (prev ? Object.assign(Object.assign({}, prev), { isCodDeductible: e.target.value === "true" }) : prev)), className: "tenant_value" },
                            React.createElement(MenuItem, { value: "true" }, "True"),
                            React.createElement(MenuItem, { value: "false" }, "False"))),
                    React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                        React.createElement(Button, { variant: "contained", className: "or_group_button_height", sx: { width: "146px", textTransform: "none" }, onClick: handleSaveAccountType }, "Save"))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "Wallet Operation"),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 10.5 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Operation"),
                        React.createElement(Select, { style: { width: "30%" }, size: "small", value: walletOperationType, onChange: (e) => setWalletOperationType(e.target.value), className: "tenant_value" },
                            React.createElement(MenuItem, { value: "credit" }, "Credit"),
                            React.createElement(MenuItem, { value: "debit" }, "Debit")))),
                walletOperationType === "credit" && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { container: true, spacing: 2, mt: 1 },
                        React.createElement(Grid, { item: true, xs: 10.5 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Recharge type"),
                            React.createElement(Select, { style: { width: "30%" }, size: "small", value: rechargeType, onChange: (e) => setRechargeType(e.target.value), className: "tenant_value" },
                                React.createElement(MenuItem, { value: "Cashback" }, "Cashback"),
                                React.createElement(MenuItem, { value: "Credit" }, "Credit"))),
                        React.createElement(Grid, { item: true, xs: 10.5 },
                            React.createElement(Typography, { className: "tenant_key" }, "Add amount"),
                            React.createElement(TextField, { variant: "outlined", style: { width: "30%" }, size: "small", value: addAmount, onChange: (e) => {
                                    const value = e.target.value;
                                    // Only allow numbers or empty string
                                    if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
                                        setAddAmount(value === "" ? "" : parseFloat(value));
                                    }
                                } })),
                        React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                            React.createElement(Button, { variant: "contained", disabled: !addAmount || !rechargeType, className: "or_group_button_height", sx: { width: "146px", textTransform: "none" }, onClick: () => handleSaveClick("add") }, "Submit"))))),
                walletOperationType === "debit" && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { container: true, spacing: 2, mt: 1 },
                        React.createElement(Grid, { item: true, xs: 10.5 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Deduction type"),
                            React.createElement(Select, { style: { width: "30%" }, size: "small", value: deductType, onChange: (e) => setDeductType(e.target.value), className: "tenant_value" }, DEDUCTION_TYPES.map((item) => (React.createElement(MenuItem, { key: item.key, value: item.key }, item.value))))),
                        React.createElement(Grid, { item: true, xs: 10.5 },
                            React.createElement(Typography, { className: "tenant_key" }, "Deduction amount"),
                            React.createElement(TextField, { variant: "outlined", style: { width: "30%" }, size: "small", value: deductAmount, onChange: (e) => {
                                    const value = e.target.value;
                                    // Only allow numbers or empty string
                                    if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
                                        setDeductAmount(value === "" ? "" : parseFloat(value));
                                    }
                                } })),
                        React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                            React.createElement(Button, { variant: "contained", className: "or_group_button_height", disabled: !deductAmount || !deductType, sx: { width: "146px", textTransform: "none" }, onClick: () => handleSaveClick("deduct") }, "Submit"))))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "COD deduction configuration"),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 10.5 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Deduct shipment charges from COD remittance"),
                        React.createElement(Select, { style: { width: "30%" }, size: "small", value: "Yes", className: "tenant_value", disabled: true },
                            React.createElement(MenuItem, { value: "Yes" }, "Yes"),
                            React.createElement(MenuItem, { value: "No" }, "No"))),
                    React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                        React.createElement(Button, { variant: "contained", className: "or_group_button_height", sx: { width: "146px", textTransform: "none" }, disabled: true }, "Save"))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "KYC details"),
                React.createElement(Divider, { className: "m_divider", sx: { mb: 2 } }),
                React.createElement(KYCdetails, null),
                React.createElement(Grid, { item: true, xs: 12, sx: { mt: 2, display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { variant: "outlined", onClick: () => handleKYCstateUpdate("rejected"), sx: { width: "146px", borderColor: "#121114", color: "#121114", mr: 1, textTransform: "none" } }, "Reject"),
                    React.createElement(Button, { variant: "contained", onClick: () => handleKYCstateUpdate("verified"), className: "or_group_button_height", sx: { width: "146px", textTransform: "none" } }, "Approve")))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "Seller wallet plan configuration"),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Current Plan"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, activePlan))),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 10.5 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Change wallet plan"),
                        React.createElement(Select, { style: { width: "30%" }, size: "small", value: selectedTier, className: "tenant_value", onChange: (e) => setSelectedTier(e.target.value) }, walletTiers.map((tier) => (React.createElement(MenuItem, { key: tier.tierName, value: tier.tierName }, tier.tierName))))),
                    React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                        React.createElement(Button, { variant: "contained", className: "or_group_button_height", sx: { width: "146px", textTransform: "none" }, onClick: HandleSaveWalletPlan }, "Save"))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "Remittance / Payout Cycle"),
                React.createElement(Typography, { className: "m_font_size_10 m_tag_font", sx: { mb: 1 } }, "Define the days of the week on which COD amounts will be remitted to your bank account after calculation."),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Current Payout Frequency"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, activePayoutCycle ? `${activePayoutCycle} Days a week` : "NA"))),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 10.5 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Change Payout Cycle"),
                        React.createElement(Select, { style: { width: "30%" }, size: "small", value: selectedPayoutCycle, className: "tenant_value", onChange: (e) => setSelectedPayoutCycle(e.target.value) },
                            React.createElement(MenuItem, { key: "2", value: "2" }, "2 Days a week (Tuesday and Friday)"),
                            React.createElement(MenuItem, { key: "3", value: "3" }, "3 Days a week (Monday, Wednesday, Friday)"),
                            React.createElement(MenuItem, { key: "5", value: "5" }, "5 Days a week (Monday to Friday)"))),
                    React.createElement(Grid, { item: true, xs: 1.5, sx: { mt: 3 } },
                        React.createElement(Button, { variant: "contained", disabled: !selectedPayoutCycle, className: "or_group_button_height", sx: { width: "146px", textTransform: "none" }, onClick: HandleSaveRemittancePayoutCycle }, "Save"))))),
        React.createElement(Card, { variant: "outlined", style: { marginBottom: "16px", height: "220px" } },
            React.createElement(CardContent, null,
                React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 600, fontSize: "16px", color: "#121114", mb: 1 } }, "Billing Cycle"),
                React.createElement(Typography, { className: "m_font_size_10 m_tag_font", sx: { mb: 1 } }, "Define the days on which COD calculation will be done."),
                React.createElement(Divider, { className: "m_divider" }),
                React.createElement(Grid, { container: true, spacing: 2, mt: 0.5 },
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Current billing cycle"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, currentBillingCycle ? `${currentBillingCycle}` : "NA"),
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5, mt: 2 }, "Start date"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, getDateString(Number(currentBillingCycleStartTimestamp), "Do MMM hh:mm A"))),
                    React.createElement(Grid, { item: true, xs: 2 },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Upcoming billing cycle"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, upcomingBillingCycle ? `${upcomingBillingCycle}` : "NA"),
                        React.createElement(Typography, { className: "tenant_key", mb: 0.5, mt: 2 }, "Upcoming start date"),
                        React.createElement(Typography, { sx: { fontFamily: "poppins", fontWeight: 400, fontSize: "14px", color: "#121114" } }, getDateString(Number(upcomingBillingCycleStartTimestamp), "Do MMM hh:mm A"))))))));
};
export default TenantManagerDetails;
